import React, { useState } from 'react';
import { StyledSwitchContainer } from './DomainSection.styled';
import { StyledFormContainer, StyledPaperContainer, StyledSectionTitle, StyledSwitch } from '../../PlusWebsiteEditor.styles';
import { InputField } from '../../../../healtheraComponents';
import { WebsiteConfiguration } from '../../types/websiteConfiguration';
import { BlurHandler, DeepFieldErrorGetter } from '../../types/handlers';
import { formatUrl } from '../../utils/format';
import { fullUrlRegexp } from '../../constants';

type Props = Pick<WebsiteConfiguration, 'domain' | 'homepage_url'> & {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFieldChange: (fieldName: string, value: string | boolean) => void;
  getError: DeepFieldErrorGetter;
  onBlur: BlurHandler;
};

const DomainSection = ({ domain, homepage_url, onChange, onFieldChange, getError, onBlur }: Props) => {
  const [shouldNavigateToExternalHomepage, setShouldNavigateToExternalHomepage] = useState(!!homepage_url);

  const handleSwitch = (_: any, checked: boolean) => {
    if (!checked) onFieldChange('homepage_url', '');
    setShouldNavigateToExternalHomepage(checked);
  };

  const handleBlur: BlurHandler = async (e) => {
    await onBlur(e);

    if (e.target?.value.match(fullUrlRegexp)) {
      onFieldChange(e.target.name, formatUrl(e.target.value));
    }
  };

  return (
    <StyledPaperContainer>
      <StyledSectionTitle>Domain</StyledSectionTitle>
      <StyledFormContainer>
        <InputField helperText={getError('domain')} onBlur={handleBlur} onChange={onChange} name="domain" value={domain || ''} margintop="unset" label="Domain" placeholder="https://app.healthera.co.uk" />
        <StyledSwitchContainer>
          <StyledSwitch onChange={handleSwitch} value={shouldNavigateToExternalHomepage} label="Navigate back to Customer's own home page by clicking the Nav Bar logo, rather than our home page" />
        </StyledSwitchContainer>
        {shouldNavigateToExternalHomepage && (
          <InputField
            helperText={getError('homepage_url')}
            onBlur={handleBlur}
            onChange={onChange}
            name="homepage_url"
            value={homepage_url}
            margintop="10px"
            label="Homepage URL"
            placeholder="https://healthera.co.uk"
          />
        )}
      </StyledFormContainer>
    </StyledPaperContainer>
  );
};

export default DomainSection;
